import { UTCDateMini } from '@date-fns/utc';
import {
  format,
  isAfter,
  isValid,
  parse,
  parseISO,
  startOfDay,
  addHours,
  differenceInDays,
  subYears,
  subMonths,
  endOfMonth,
  startOfMonth,
} from 'date-fns';

// FIXME: Doesn't take daylight saving into account, might need date-fns time zone package for that
export const getTodayCET = (): Date => startOfDay(addHours(new UTCDateMini(), 1));

export const isAfterTodayCET = (date: Date): boolean => isAfter(date, getTodayCET());

export const stringToDate = (date: string): Date => parseISO(date);

export const oneYearBack = (): Date => subYears(getTodayCET(), 1);

export const defaultSerializeDate = (date: Date | null): string => {
  if (!date) return '';
  // Return NaN if date is invalid, so that we can validate on erroneous or incomplete input
  if (!isValid(date)) return date.valueOf().toString();
  return format(date, 'yyyy-MM-dd');
};

export const getDateWithoutTimezone = (year: number, month: number, day: number): Date => {
  const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  return parse(dateStr, 'yyyy-MM-dd', new Date());
};

export const normalizeToDateWithoutTimezone = (date: Date): Date => {
  const dateStr = format(date, 'yyyy-MM-dd');
  return parse(dateStr, 'yyyy-MM-dd', new Date());
};

export const getDaysBetweenDates = (date1: Date, date2: Date): number => {
  return differenceInDays(date1, date2);
};

export const lastMonthName = (): string => format(subMonths(new Date(), 1), 'MMMM yyyy');

export const formatIsoUtcTimestampToLocalDateTime = (isoTimestamp: string): string => {
  const date = parseISO(isoTimestamp);
  if (!isValid(date)) return '';
  return format(date, 'yyyy-MM-dd HH:mm');
};

export const getLastMonthDateRange = () => {
  const lastMonth = subMonths(new Date(), 1);
  const start = startOfMonth(lastMonth);
  const end = endOfMonth(lastMonth);
  return {
    monthName: lastMonthName(),
    creationDateStart: format(start, 'yyyy-MM-dd'),
    creationDateEnd: format(end, 'yyyy-MM-dd'),
  };
};
